import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Home from './pages/Home/Home';
import Acceso from './pages/Acceso/Acceso';
import Buscar from './pages/Buscar/Buscar';
import MisTurnosVista from './pages/MisTurnos/MisTurnosVista';
import MedicoAgenda from './pages/Medico/MedicoAgenda';
import MedicoDisponibilidad from './pages/Medico/MedicoDisponibilidad';
import MedicoServicios from './pages/Medico/MedicoServicios';
import Notificaciones from './pages/Notificaciones/Notificaciones';
import Componentes from './pages/Componentes/Componentes';
import NotFound from './pages/NotFound/NotFound';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/acceso" element={<Acceso />} />
        <Route path="/buscar" element={<Buscar />} />
        <Route path="/mis-turnos" element={<MisTurnosVista />} />
        <Route path="/medico/agenda" element={<MedicoAgenda />} />
        <Route path="/medico/disponibilidad" element={<MedicoDisponibilidad />} />
        <Route path="/medico/servicios" element={<MedicoServicios />} />
        <Route path="/notificaciones" element={<Notificaciones />} />
        <Route path="/componentes" element={<Componentes />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
